import { useState } from "react";
import { Modal } from "antd";

export default function Footer()
{
    const [isPrivacyPolicy, setIsPrivacyPolicy] = useState(false);

    const togglePrivacyPolicy = () => {
        setIsPrivacyPolicy(!isPrivacyPolicy);
    }

    return(
        <>
            <Modal title={'Privacy Policy'} width={window.innerWidth > 780 ? 600 : "100%"} visible={isPrivacyPolicy} onCancel={()=> setIsPrivacyPolicy(false)} centered  destroyOnClose={true} footer={null}>
                <h2>Effective Date: 9/1/2024</h2>
                <p>
                    At YJC and Wellness, we value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data when you visit our website <a href="https://yjcandwellness.com/">https://yjcandwellness.com/</a>.
                </p>

                <h3>Information We Collect</h3>
                <ul>
                    <li><strong>Personal Information:</strong> We collect details you provide, such as your name, email, or phone number.</li>
                    <li><strong>Usage Data:</strong> We may collect anonymous information such as IP addresses and browser types to improve our website.</li>
                    <li><strong>Cookies:</strong> We use cookies to enhance your experience and track site usage.</li>
                </ul>

                <h3>How We Use Your Information</h3>
                <ul>
                    <li>To personalize your experience and improve our services.</li>
                    <li>To respond to your inquiries and communicate updates.</li>
                    <li>For legal compliance and to protect our rights.</li>
                </ul>

                <h3>Data Sharing</h3>
                <p>We do not sell your personal information. We may share it with service providers who assist in running our website or if required by law.</p>

                <h3>Security</h3>
                <p>We take reasonable steps to protect your data, but no online service is fully secure.</p>

                <h3>Your Rights</h3>
                <p>You may request access, correction, or deletion of your personal information by contacting us.</p>

                <h3>Third-Party Links</h3>
                <p>Our site may contain links to other websites. We are not responsible for their privacy practices.</p>

                <h3>Children's Privacy</h3>
                <p>Our website is not intended for children under 13, and we do not knowingly collect data from them.</p>

                <h3>Changes to This Policy</h3>
                <p>We may update this Privacy Policy. Any changes will be posted on this page with the updated date.</p>

                <h3>Contact Us</h3>
                <p>If you have any questions, contact us at: <a href="mailto:info@yjcandwellness.com">info@yjcandwellness.com</a></p>
            </Modal>
            <footer className="footer">
                <div className="footer-content">
                    <p>Copyright © 2024 – YJC and Wellness All Rights Reserved.</p>
                    <div className="footer-links">
                        <button 
                            type="button"
                            onClick={togglePrivacyPolicy}
                            style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', padding: 0, font: 'inherit', textDecoration: 'underline' }}
                        >
                            Privacy Policy
                        </button>
                        <span> | </span>
                        <a href="mailto:info@yjcandwellness.com">Contact Us</a>
                    </div>
                </div>
            </footer>
        </>
    )
}

